export default __webpack_public_path__ + "static/media/Kutalia.1982be3d.png";